import * as React from 'react';
import { CSSTransition } from 'react-transition-group';

const styles = require('./TransitionStage.scss');

export enum TransitionEffects {
    slideUpIn = 'slideUpIn',
    slideDownOut = 'slideDownOut',
    slideDownIn = 'slideDownIn',
    slideUpOut = 'slideUpOut',
    sweepUpIn = 'sweepUpIn',
    sweepDownOut = 'sweepDownOut',
    fadeIn = 'fadeIn',
    fadeOut = 'fadeOut',
}

export interface TransitionStageProps {
    open?: boolean;
    appear?: boolean;
    inEffect?: string;
    outEffect?: string;
    transitionDuration?: number;
    children?: any;
    mountOnEnter?: boolean;
    onMounted?: () => void;
    unmountOnExit: boolean;
    onUnmounted?: () => void;
}

export default function TransitionStage(props: TransitionStageProps) {
    const {
        open,
        appear,
        inEffect,
        outEffect,
        transitionDuration,
        children,
        mountOnEnter,
        onMounted,
        unmountOnExit,
        onUnmounted,
    } = props;

    // TODO davisj evaluate other libraries

    const getEffectClassNames = (inEffect: string, outEffect: string) => {
        const enterClassName = styles[inEffect];
        const enterPendingClassName = styles[inEffect + 'Pending'];
        const exitClassName = styles[outEffect];

        return {
            appear: enterPendingClassName,
            appearActive: enterClassName,
            enter: enterPendingClassName,
            enterActive: enterClassName,
            enterDone: enterClassName,
            // exit: ,
            exitActive: exitClassName,
            exitDone: exitClassName,
        };
    };

    return (
        <CSSTransition
            in={open}
            appear={appear}
            timeout={transitionDuration}
            classNames={getEffectClassNames(inEffect, outEffect)}
            mountOnEnter={mountOnEnter}
            unmountOnExit={unmountOnExit}
            onEntered={onMounted}
            onExited={onUnmounted}>
            {children}
        </CSSTransition>
    );
}

TransitionStage.defaultProps = {
    open: false,
    appear: true,
    inEffect: TransitionEffects.slideUpIn,
    outEffect: TransitionEffects.slideDownOut,
    transitionDuration: 300,
    mountOnEnter: true,
    unmountOnExit: true,
};
